import { useConfigContext } from '../context/ConfigContext';

/** Layout, theme, and feature flags — navigation modules come from DB via `useNavigationModules`. */
export const useConfig = () => useConfigContext();
